import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

interface StructuredDataProps {
  data: Record<string, unknown>;
}

export default function StructuredData({ data }: StructuredDataProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    const script = document.querySelector('script[type="application/ld+json"]');
    if (script) {
      script.remove();
    }
    const newScript = document.createElement('script');
    newScript.type = 'application/ld+json';
    newScript.textContent = JSON.stringify(data, null, 2);
    document.head.appendChild(newScript);

    return () => {
      if (newScript.parentNode) {
        newScript.parentNode.removeChild(newScript);
      }
    };
  }, [pathname, data]);

  return null;
}